import React, { Component } from 'react';

class TopContainer extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let chatIcon='chat-fml';
        let chatLang='';
        this.props.iconbot==='male'?chatIcon='chat-ml':chatIcon='chat-fml';
        this.props.language==='en'?chatLang='':chatLang='chat-mirror';
        return(
            <div className="frame-content">
                <div className="widget-position-right sidebar-position-right chatSize1">
                    <div className={`chat no-clip-path not-ie chrome chat-prm ${chatIcon} ${chatLang}`}>
                        {this.props.children}
                    </div>
                </div>
            </div>       
        )
    }
}
TopContainer.propTypes = {
    iconbot: React.propTypes.node,
    children: React.propTypes.node,
    language: React.propTypes.node,
}
export default TopContainer;